var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTablerTargetArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 133,
    viewBox: "0 0 133 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.5 72.0416C69.5606 72.0416 72.0417 69.5605 72.0417 66.4999C72.0417 63.4393 69.5606 60.9583 66.5 60.9583C63.4395 60.9583 60.9584 63.4393 60.9584 66.4999C60.9584 69.5605 63.4395 72.0416 66.5 72.0416Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5 38.7916C61.0198 38.7916 55.6627 40.4167 51.106 43.4613C46.5494 46.506 42.998 50.8334 40.9008 55.8964C38.8036 60.9595 38.2549 66.5307 39.324 71.9056C40.3932 77.2805 43.0321 82.2176 46.9072 86.0927C50.7823 89.9678 55.7195 92.6068 61.0943 93.6759C66.4692 94.745 72.0405 94.1963 77.1035 92.0991C82.1665 90.0019 86.494 86.4505 89.5386 81.8939C92.5832 77.3373 94.2083 71.9801 94.2083 66.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0638 16.9298C61.7899 15.7772 51.4118 17.8457 42.3649 22.8492C33.3181 27.8527 26.0496 35.544 21.5651 44.859C17.0805 54.174 15.6014 64.6524 17.3324 74.8448C19.0635 85.0372 23.9191 94.4397 31.2275 101.752C38.536 109.064 47.9361 113.924 58.1276 115.661C68.3191 117.397 78.7983 115.923 88.1156 111.443C97.4328 106.963 105.128 99.6986 110.136 90.6542C115.144 81.6099 117.218 71.2327 116.07 60.9583",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M83.125 49.875L66.5 66.5M83.125 33.25V49.875H99.75L116.375 33.25H99.75V16.625L83.125 33.25Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTablerTargetArrow);
export default __webpack_public_path__ + "static/media/tabler_target-arrow.f873ad9b9ff99fa7f917f533e427db5e.svg";
export { ForwardRef as ReactComponent };